import React, { useState } from "react";
import styled from "styled-components";

const GoalTracker = () => {
  const [goals, setGoals] = useState([]);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [deadline, setDeadline] = useState("");

  const addGoal = (e) => {
    e.preventDefault();
    if (!name) return;
    const newGoal = {
      id: Date.now(),
      name,
      description,
      deadline,
      progress: 0,
      completed: false,
    };
    setGoals([...goals, newGoal]);
    setName("");
    setDescription("");
    setDeadline("");
  };

  const updateProgress = (id, progress) => {
    setGoals((prevGoals) =>
      prevGoals.map((goal) =>
        goal.id === id ? { ...goal, progress: parseInt(progress) } : goal
      )
    );
  };

  const markAsCompleted = (id) => {
    setGoals((prevGoals) =>
      prevGoals.map((goal) =>
        goal.id === id ? { ...goal, completed: true, progress: 100 } : goal
      )
    );
  };

  return (
    <GoalTrackerContainer>
      <Title>Goal Tracker</Title>
      <GoalForm onSubmit={addGoal}>
        <Input
          type="text"
          placeholder="Goal Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <Input
          type="text"
          placeholder="Description (Optional)"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
        <Input
          type="date"
          placeholder="Deadline"
          value={deadline}
          onChange={(e) => setDeadline(e.target.value)}
        />
        <Button type="submit">Add Goal</Button>
      </GoalForm>

      <GoalList>
        {goals.map((goal) => (
          <GoalItem key={goal.id}>
            <GoalName>{goal.name}</GoalName>
            {goal.description && <Description>{goal.description}</Description>}
            {goal.deadline && (
              <Description>Deadline: {goal.deadline}</Description>
            )}
            <ProgressBar progress={goal.progress}>
              <div />
            </ProgressBar>
            <Actions>
              <Input
                type="number"
                min="0"
                max="100"
                placeholder="Progress %"
                onChange={(e) => updateProgress(goal.id, e.target.value)}
              />
              <ActionButton
                onClick={() => markAsCompleted(goal.id)}
                completed={goal.completed}
              >
                {goal.completed ? "Completed" : "Mark as Completed"}
              </ActionButton>
            </Actions>
          </GoalItem>
        ))}
      </GoalList>
    </GoalTrackerContainer>
  );
};
const GoalTrackerContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  margin-top: 10px;
  padding: 20px;
  background-color: #171c29;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  color: white;
  border-radius: 20px;
  font-family: "Comfortaa";
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 1em;
`;

const GoalForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
`;

const Input = styled.input`
  padding: 15px;
  border: none;
  outline: none;
  color: white;
  border-radius: 17px;
  font-size: 1rem;
  background: #20273a;
  font-family: "Comfortaa";
`;

const Button = styled.button`
  padding: 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 1rem;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }
`;

const GoalList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const GoalItem = styled.div`
  padding: 15px;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const GoalName = styled.div`
  font-size: 1.2rem;
  font-weight: bold;
  color: #333;
`;

const Description = styled.div`
  color: #666;
`;

const ProgressBar = styled.div`
  background-color: #eee;
  border-radius: 8px;
  overflow: hidden;
  height: 10px;

  & > div {
    height: 100%;
    background-color: #28a745;
    width: ${(props) => props.progress || 0}%;
    transition: width 0.3s ease;
  }
`;

const Actions = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ActionButton = styled.button`
  padding: 8px 10px;
  background-color: ${(props) => (props.completed ? "#28a745" : "#ffc107")};
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;

export default GoalTracker;
